import { useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { AsyncButton } from "../components/ui/AsyncButton.js"
import Container from "../components/ui/Container.js"
import { api } from "../services/api/index.js"
import { useQuery } from "../hooks/useQuery"
import { Captcha } from "../components/Captcha.js"
import toast from "react-hot-toast"
import { ModalError } from "../components/ui/modal/ModalError"
import { ModalOk } from "../components/ui/modal/ModalOk"
import { msg } from "../components/ui/modal/utils"

const Sugerencias = () => {
  const { t } = useTranslation()

  const [captcha, setCaptchaRes] = useState(null)

  const form = useRef()

  // estado
  const [text, setText] = useState()

  // ajax
  const query = useQuery(),
    showRes = useState(false)

  const onSubmitForm = async (e) => {
    e.preventDefault()

    // check CAPTCHA
    if (captcha === null) toast.error(t(`ui.msgs.empty_CAPTCHA`))
    else if (!captcha) toast.error(t(`ui.msgs.CAPTCHA_wrong`))
    if (!captcha) return

    showRes[1](true)

    const { url, opt } = api.suggestions.create({ sugg: { text } })

    query.url.current = url
    query.opt.current = opt

    query.run({
      onOk: (data) => {
        form.current.reset()
      },
    })
  }

  return (
    <>
      {!query.isPending && query.res && query.err && (
        <ModalError show={showRes} res={query.res} />
      )}

      {!query.isPending && query.res && !query.err && (
        <ModalOk
          show={showRes}
          body={msg(t(`modals.modal_submit_suggestion.sucess_msg`))}
        />
      )}

      <Container>
        <div className="col-lg-4 col-md-8 col-12 mx-auto">
          <h3>{t(`suggestions.title`)}</h3>
          <p>{t(`suggestions.sub_title`)}</p>

          <div className="flex-row my-3">
            <form ref={form}>
              <textarea
                onChange={(e) => setText(e.target.value)}
                style={{ minHeight: "40vh" }}
                className="form-control"
                rows="3"
                placeholder={t(`suggestions.write_here`)}
              ></textarea>

              <div className="flex-row d-flex justify-content-between my-3 w-100">
                <Captcha min={2} max={9} setOk={setCaptchaRes} />
                <AsyncButton
                  onClick={(e) => onSubmitForm(e)}
                  name={t(`ui.btns.submit`)}
                  sendingName={t(`ui.btns.submiting`)}
                  disabled={query.isPending}
                  sending={query.isPending}
                />
              </div>
            </form>
          </div>
        </div>
      </Container>
    </>
  )
}

export default Sugerencias
